<dx-select-box [items]="domains"
               [(value)]="id"
               displayExpr="name"
               valueExpr="id"
               [height]="height"
               [searchEnabled]="true"
               placeholder="Sélection..."
               (onValueChanged)="save($event)">
  <!--  <dxi-button name="refresh-trackers" [options]="refreshBtn" location="after"></dxi-button>-->
</dx-select-box>
